import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Import components
import ParentDashboard from '../components/parents/ParentDashboard';
import ChildManagement from '../components/parents/ChildManagement';
import ChildProgress from '../components/parents/ChildProgress';
import SchoolSearch from '../components/parents/SchoolSearch';
import EcommerceShop from '../components/parents/EcommerceShop';
import ParentProfile from '../components/parents/ParentProfile';
import ParentSettings from '../components/parents/ParentSettings';
import MessageCenter from '../components/parents/MessageCenter';
import SubscriptionPage from '../components/dashboard/SubscriptionPage';
import Checkout from '../pages/dashboard/Checkout';
import NotFound from '../pages/public/NotFound';
import HelpCenter from '../components/students/HelpCenter';

/**
 * Nested routes configuration for the parent panel
 */
const ParentRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<ParentDashboard />} />
      <Route path="/dashboard" element={<Navigate to="/parent" replace />} />
      <Route path="/students" element={<ChildManagement />} />
      <Route path="/progress" element={<ChildProgress />} />
      <Route path="/schools" element={<SchoolSearch />} />
      <Route path="/shop" element={<EcommerceShop />} />
      <Route path="/profile" element={<ParentProfile />} />
      <Route path="/settings" element={<ParentSettings />} />
      <Route path="/subscription" element={<SubscriptionPage userType="parent" />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/support" element={<HelpCenter />} />
      <Route path="/messages" element={<MessageCenter />} />
      <Route path="/mentors" element={<Navigate to="/find-expert" replace />} />
      
      {/* Routes that redirect to appropriate existing pages or show not found */}
      <Route path="/classes" element={<Navigate to="/parent/students" replace />} />
      <Route path="/teachers" element={<Navigate to="/parent/schools" replace />} />
      <Route path="/schedule" element={<Navigate to="/parent" replace />} />
      <Route path="/payments" element={<Navigate to="/parent/subscription" replace />} />
      
      {/* Add any other parent-specific routes here */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default ParentRoutes; 